<template>
  <div class="firs-day-of-week-block">
    <v-layout pa-2 mt-2>
      <v-flex>
        <v-card>
          <v-card-title>
            <i class="material-icons light-blue--text">date_range</i>
            <div class="headline">&nbsp;First Day of the week:</div>
          </v-card-title>
            <v-layout row wrap >
              <v-flex xs12 sm12 md12 lg8 pa-2 mb-2 >
                <v-form ref="change_password" data-vv-scope="change_password" lazy-validation>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-radio-group v-model="firstDayOfWeek" class="my-0 px-2">
                        <v-radio label="Sunday" value="0"></v-radio>
                        <v-radio label="Monday" value="1"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-form>
                <v-btn color="primary" class="submit"
                  @click="changeFirstDayOfWeek()"
                  :loading="loading"
                  :disabled="loading"
                >Save first day of week</v-btn>
              </v-flex>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'FirstDayOfWeekBlock',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      loading: false,
      firstDayOfWeek: this.$store.state.user.first_day_of_week + ''
    }
  },
  methods: {
    changeFirstDayOfWeek () {
      this.loading = true
      this.$store.dispatch('FIRST_DAY_OF_WEEK', parseInt(this.firstDayOfWeek)).then(res => {
        this.$store.dispatch('GET_USER_DATA')
        this.loading = false
        this.$toasted.show((parseInt(this.firstDayOfWeek) === 0 ? 'Sunday' : 'Monday') + ' was set as first day of the week')
      }, err => {
        this.loading = false
        console.log('FIRST_DAY_OF_WEEK error', err)
        let errorText = this.$services.getApiError(err)
        if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/FirstDayOfWeekBlock.vue